module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAABAUlEQVQokXXQvSuGYRQG8N/zegiJkn/ASFGU1Wy4LYqFxWQ0WeTjSTIp02u0Kovl+AdY380sdjJI+QyD+6kXuZbTua7rvs65T1FVlRoppR7sYBjX2IqIp1pv+IljzGTjTO79MaeUVjEaEWMRsRYRYxjN/J/kCTR/TWpism6KqqqklMZxjlucoMAnFjCE6Yi4LFqt1jJ2cYYuDOAdJR7wjFlslFjEUURs+gcppTss1a9v2oRB7GE9Iu4zfYWRBj7Q0xbUj5Vca/Tio5E/89YmPOI01xqvKEr0obNmI+IOc7/W7kV/iQts5/O9oCMndfk+H8yjWeIA3ZjK5nYUeeoh9r8AWq5Irgl9KJwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/img/event/lock.png
// module id = 1A2q
// module chunks = 32